export default __webpack_public_path__ + "static/media/Services - recruitment.0f40eb5c.jpg";